// Copyright 2020 Drivetrain Hub LLC
// Configure defaults for Element-UI, chart.js, pixi.js and three.js for use throughout Vue app.
// https://vuejs.org/v2/guide/plugins.html

import {MeshPhongMaterial} from "three";
import * as PIXI from './pixi'

// Cannot type hint PluginObject without losing variable resolution.
// eslint-disable-next-line no-unused-vars
import { PluginFunction } from "vue";

// pixi global settings; required for smooth arcs
PIXI.GRAPHICS_CURVES.adaptive = true;
PIXI.GRAPHICS_CURVES.maxLength = 0.5;

// plotly global settings; MathJax configured separately
// https://github.com/plotly/plotly.js/issues/4563
window.PlotlyConfig = {MathJaxConfig: 'local'};

export const COLORS = {
  background: 'rgb(96, 98, 102)',  // var(--color), 0x606266
  backgroundAlpha: 'rgb(96, 98, 102, .2)',
  border: 'rgb(64, 158, 255)',  // var(--color-hover), 0x409EFF
  none: 'rgba(0, 0, 0, 0)',
  default: 'rgba(0, 0, 0, 0.15)',
};

/** @alias $defaults */
const Defaults = {
  notifyPosition: "bottom-right",
  notifyMessageFail: "Failed to update, please try again",
  messageNotifySupport: "Problem encountered, please notify customer support",
  loadingBackground: 'rgba(245, 247, 250, 0.9)',  // theme background color
  tooltipDelay: 500,
  colors: COLORS,
  chart: {
    lineDataset: {
      backgroundColor: COLORS.background,
      borderColor: COLORS.border,
      lineTension: 0,
      pointRadius: 0,
    },
    options: {
      // NOTE: responsive: false removes the issue of resize transition but then chart resizing is complicated
      maintainAspectRatio: false,  // required to fit canvas to pane size
      animation: {
        duration: 300,
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          type: 'linear',
          display: false,
        }],
      }
    }
  },
  three: {
    material: new MeshPhongMaterial({
      color: 0x95a6bb, // 0x606266 (--color), 0x909399 (--color-secondary), 0x95a6bb (gunmetal)
      emissive: 0xffffff,  // default=0x0, 0x409EFF (blue-ish)
      emissiveIntensity: .05,  // default=1
      transparent: false,
      opacity: 1,
      // wireframe: false,
      // ENVIRONMENT MAP (see exampleDocs.js - var envMaps)
      // envMap: 'EXR',
      // reflectivity: 1,
      // refractionRatio: 0.98,  // default=0.98
    }),
    opacity: 0.5,
  },
  pixi: {
    width: 4,
    line: 0x409EFF,  // blue
    fill: 0x606266,  // gray
    nativeLineStyle: {
      width: 1,  // 0-1 allowed
      line: 0x333333,  // near black
      native: true
    },
  },
  geom: {
    carrier: {
      aspectRatio: 0.050,
      deltaDiameter: 0.075,
    }
  }
};

/** @type {PluginFunction} */
Defaults.install = function(Vue) {
  Vue.prototype.$defaults = Defaults;
};

export default Defaults
